<template>
  <va-notification
    v-if="errorMessage"
    color="danger"
    closeable
    @input="hideNotification()"
  >
    <va-badge color="danger">Error</va-badge>
    {{ errorMessage }}
  </va-notification>
</template>
<script>
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  name: 'ErrorMessage',
  mixins: [errorHandlerMixin],
  methods: {
    async disableError () {
      await this.removeError(this.errorIndex)
    },
    hideNotification () {
      this.disableError()
    },
  },
  created () {
    setTimeout(() => {
      this.hideNotification()
    }, 5000)
  },
  props: {
    errorMessage: {
      type: String,
      required: true,
    },
    errorIndex: {
      type: Number,
      required: true,
    },
  },
}
</script>
<style>

</style>
